import React, { useEffect } from 'react';
import { CallControls, CallingState, RingingCall, SpeakerLayout, StreamCall, useCalls, useCallStateHooks, useCall } from '@stream-io/video-react-sdk';

const OutgoingCalls = () => {
    const calls = useCalls();
    // console.log({ocalls: calls});
    // handle outgoing ring calls
    const outgoingCalls = calls.filter(
        (call) =>
        call.isCreatedByMe === true &&
        call.state.callingState === CallingState.RINGING,
    );
    // console.log({outgoingCalls})

    if (outgoingCalls.length < 1) {
        return null;
    }

    const [outgoingCall] = outgoingCalls;
    // console.log({ostate: outgoingCall.state.callingState})
    if (outgoingCall.state.callingState !== CallingState.RINGING) {
        return null;
    }

    if (outgoingCall) {
        // render the outgoing call UI
        return (
            <StreamCall call={outgoingCall} key={outgoingCall.cid}>
                <OutgoingCall />
            </StreamCall>
        );
        // return <OutgoingCallUI call={outgoingCall} />;
    }
};

const OutgoingCall = () => {
    const call = useCall();
    const { useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState();

    // const { useParticipants } = useCallStateHooks();
    // const { participants } = useParticipants();

    // if (!call || call.state.status !== 'ringing') {
    //     return null; // Or render a different state if not in outgoing call
    // }

    // const otherParticipants = participants.filter(p => !p.isLocal);

    useEffect(() => {
        if (!call) return;
        // const myCall = client.call(callType, callId);
        // myCall.join({ create: true }).then(
        //     () => setCall(myCall),
        //     () => console.error("Failed to join the call"),
        // );
        return () => {
            if (call) {
                call.leave().catch(() => console.error('Failed to leave the outgoing call'));
            }
            // setCall(undefined);
        };
    }, [call]);

    if (callingState === CallingState.RINGING) {
        return <div className="call-panel">
            <RingingCall />
        </div>;
    }

    return (
        <>
            <SpeakerLayout />
            {/* <CallControls onLeave={handleCallLeave} /> */}
            <CallControls />
        </>
    );
};

  export default OutgoingCalls;